import { useImportedStoriesQuery } from "@/shared/services/pages/pages.query";
import type { TImportedPage } from "@/shared/services/pages/types";

const NONE: TImportedPage[] = [];

export const useRecentImports = (): TImportedPage[] => {
  const { data } = useImportedStoriesQuery();
  return data?.length ? data : NONE;
};
